module.exports = __webpack_public_path__ + "mainassets/img/uniqueForm.e124ee97.svg";